
riot.tag2('textresize', '<div class="textsize"> <div each="{size, i in sizes}" riot-style="font-size:{(fontsize + (i * 2))}px" onclick="{setSize.bind(null, size)}" class="textsize__item {\'textsize__item--active\': selected == size.style}">{size.label}</div> </div>', '.textsize__item { border: 1px solid #ccc; height: 30px; line-height: 30px; white-space: nowrap; float: left; padding: 0 8px; margin-left: 5px; cursor: pointer; } .textsize__item--active { color: #000; }', '', function(opts) {
this.on('mount', function() {
  var ref;
  this.fontsize = opts.fontsize ? opts.fontsize : 12;
  this.sizes = opts.sizes ? opts.sizes : [
    {
      label: 'A',
      style: ''
    }, {
      label: 'A',
      style: 'large'
    }, {
      label: 'A',
      style: 'larger'
    }
  ];
  this.selected = (ref = window.localStorage) != null ? ref.getItem("textsize") : void 0;
  if (this.selected) {
    console.log("size", this.selected);
    this.updateClasses(this.selected);
  }
  return this.update();
});

this.setSize = (function(_this) {
  return function(size) {
    var ref;
    _this.selected = size.style;
    if ((ref = window.localStorage) != null) {
      ref.setItem("textsize", _this.selected);
    }
    _this.updateClasses(size.style);
    return _this.update();
  };
})(this);

this.updateClasses = function(newClass) {
  var bodyClasses;
  bodyClasses = document.body.className.split(/\s+/) || [];
  this.sizes.forEach((function(_this) {
    return function(size) {
      var idx;
      if (size.style != null) {
        idx = bodyClasses.indexOf(size.style);
      }
      if (idx > -1) {
        return bodyClasses = bodyClasses.splice(idx, 1);
      }
    };
  })(this));
  if (newClass != null) {
    bodyClasses.push(newClass);
  }
  return document.body.className = bodyClasses.join(' ');
};
});